<template>
  <v-btn :value="view.name" class="ma-0" :aria-label="view.altText" @click="$emit('changed', view)">
    <v-icon :size="24">{{ view.icon }}</v-icon>
    <span v-if="view.label && $vuetify.display.mdAndUp" ref="label" class="ml-1">
      {{ view.label }}
    </span>
    <v-badge :offset-x="-10" :offset-y="-10" dot :model-value="showBadge" color="primary" />
  </v-btn>
</template>

<script setup lang="ts">
import { ViewToggle } from '@/types'
import { computed, PropType } from 'vue'

const props = defineProps({
  view: {
    type: Object as PropType<ViewToggle<string>>,
    required: true
  }
})

defineEmits<{
  changed: [ViewToggle<string>]
}>()

if (props.view.restriction() && props.view.count) {
  props.view.count.loadFunction()
}

const showBadge = computed(() => props.view.count != undefined && props.view.count.getter())
</script>
